module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.locked ? "list-of-portfolio locked" : "list-of-portfolio"
  }, [(!_vm.items.length) ? [_vm._v("\n\t\t" + _vm._s(_vm.data.nothing_to_show) + "\n\t")] : [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.items), function(item) {
    return [(!item.banner) ? [_c('transition', {
      attrs: {
        "name": "up",
        "appear": ""
      }
    }, [_c('div', {
      staticClass: "cols s_24 m_12 m___8 l___6",
      style: (_vm.order(item.order))
    }, [_c('div', {
      staticClass: "li"
    }, [_c('img', {
      attrs: {
        "src": (_vm.templatePath + "img/pf-area.jpg"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "image",
      style: (("background-image: url(\"" + (item.background) + "\")"))
    }), _vm._v(" "), _c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.date))])]), _vm._v(" "), _c('div', {
      staticClass: "header",
      domProps: {
        "innerHTML": _vm._s(item.header)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": item.a.href
      }
    }, [_c('span', {
      staticClass: "circle"
    }, [_c('svg', {
      staticClass: "svg1",
      attrs: {
        "fill": "#000000",
        "height": "24",
        "viewBox": "0 0 24 24",
        "width": "24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
      }
    })]), _vm._v(" "), _c('svg', {
      staticClass: "svg2",
      attrs: {
        "fill": "#000000",
        "height": "24",
        "viewBox": "0 0 24 24",
        "width": "24",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M0 0h24v24H0z",
        "fill": "none"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
      }
    })])]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.a.text) + "\n\t\t\t\t\t\t\t\t\t")])])])])])] : [_c('transition', {
      attrs: {
        "name": "up",
        "appear": ""
      }
    }, [_c('div', {
      class: ("" + (_vm.cols(item.size))),
      style: (_vm.order(item.order))
    }, [_c('div', {
      class: ("li banner " + (item.style))
    }, [_c('img', {
      style: (("width:" + (item.size ? "calc(50% - 15px)" : "100%"))),
      attrs: {
        "src": (_vm.templatePath + "img/pf-area.jpg"),
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "image",
      style: (("background-image: url(\"" + (item.background) + "\")"))
    }), _vm._v(" "), _c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "header",
      domProps: {
        "innerHTML": _vm._s(item.header)
      }
    }), _vm._v(" "), (item.form) ? [_c('Form', {
      attrs: {
        "dataParams": JSON.stringify(item.form)
      }
    })] : [_vm._v("\n\t\t\t\t\t\t\t\t\t\tNo params for \"Form\" component. Check API response.\n\t\t\t\t\t\t\t\t\t")]], 2)])])])]]
  })], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d65c315"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/lists/portfolio.vue
// module id = 388
// module chunks = 14